import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Badge, Button, Card, Col, Row } from "reactstrap";

import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import InvoiceComponent from "./InvoiceComponent";
import invoiceApis from "../../api/Invoice/invoice";
function ViewMaterialInvoices() {
  const { orderNumber, lineNo } = useParams();
  const [sm, setSm] = useState(false);
  const [Data,setData]=useState<any>([])
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [invoiceNumbers, setInvoiceNumbers] = useState<any>([]);
  const [activeInvoice, setActiveInvoice] = useState();

  const materialInvoice = async () => {
    try {
      const response = await invoiceApis.fetchAllInvoicesByOrderAndOrderLineNo(
        orderNumber,
        lineNo
      );
      const { data, status } = response;
      if (status && data) {
        setData(data)
        const invoiceIds:any=data?.map((item: any) => item?.invoiceNumber);
        const uniqueIds:any= Array.from(new Set(invoiceIds)).reverse();
        setInvoiceNumbers([...uniqueIds]);
        setActiveInvoice(uniqueIds[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  useEffect(() => {
    materialInvoice();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const isActive = (incoice: any): string => {
    return activeInvoice == incoice ? "active" : "";
  };
  return (
    <>
      <Head title="Material Invoice" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg 
                ${sm ? "content-active" : ""}
              `}
            >
              <div className="card-inner-group">
                <div className="card-inner">
                  <div className="user-account-info py-0">
                    <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
                      Invoice
                    </h6>
                  </div>
                </div>
                <div className="card-inner p-0">
                  <ul className="link-list-menu">
                    {invoiceNumbers.map((invoiceId: any) => {
                      const _invoiceId=Data?.find((item: any) => item?.invoiceNumber === invoiceId)?.invoiceId
                      return (
                        <li
                          onClick={() => {
                            setActiveInvoice(invoiceId);
                          }}
                        >
                          <Link to="" className={isActive(invoiceId)}>
                            <span>{_invoiceId}</span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            {activeInvoice && (
              <InvoiceComponent
                invoiceNumber={activeInvoice}
                previousPath={"/add-purchase-invoice/" + orderNumber}
              />
            )}
          </div>
        </Card>
      </Content>
    </>
  );
}

export default ViewMaterialInvoices;
